import { Gift } from 'lucide-react';
import './GiftCardBadge.css';

/** Attribute only: it makes no claim about payment, issue or redemption. */
export function GiftCardBadge() {
  return (
    <span className="crm-gift-card-badge">
      <Gift size={14} aria-hidden="true" />
      Gift card
    </span>
  );
}
